import { computed } from 'vue';
import { FeatureFlagName } from './flags';
import { useFeatureFlagsStore } from './store';

/** Переключатель фичи для пользователя: показывать, только если фича ему доступна */
export function useFeatureFlagToggle(name: FeatureFlagName) {
  const store = useFeatureFlagsStore();

  const available = computed(() => store.available[name]);

  const enabled = computed({
    get: () => store.flags[name],
    set: value => store.setChoice(name, value)
  });

  return { available, enabled };
}
